var Stats = {
    stats: [
        "peggle",
        "pengle",
        "ice",
        "pork",
        "window",
        "cylinder",
        "describe",
        "limp",
    ],

    makeInitial: function() {
        var ret = {};
        for (const stat of Stats.stats) {
            ret[stat] = 0;
        }

        return ret;
    }
}

export default Stats;